import { z } from 'zod';

/** Capture surfaces for append-only `member_treatment_plan_offers` rows. */
export const TREATMENT_PLAN_OFFER_SOURCE = ['atlas_staff'] as const;
export const treatmentPlanOfferSourceSchema = z.enum(TREATMENT_PLAN_OFFER_SOURCE);
export type TreatmentPlanOfferSource = z.infer<typeof treatmentPlanOfferSourceSchema>;
